import { Link } from 'react-router-dom';
import { useSite } from '../context/SiteContext';
import { useCategories } from '../hooks/useCategories';
import './Footer.css';

const logoSrc = `${process.env.PUBLIC_URL ?? ''}/logo.png`;

export default function Footer() {
  const { siteName, getWhatsAppUrl } = useSite();
  const { categories: davetiyeCategories } = useCategories('davetiyeler');
  const { categories: sekerlikCategories } = useCategories('sekerlik');
  const whatsappHref = getWhatsAppUrl();

  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__brand">
          <Link to="/" className="site-footer__logo">
            <img
              src={logoSrc}
              alt={siteName}
              className="site-footer__logo-img"
              width={160}
              height={60}
              loading="lazy"
              decoding="async"
            />
          </Link>
          <p className="site-footer__tagline">
            Eskişehir’de ekonomik, sade ve lüks davetiye modelleri ile şekerlik
            tasarımları.
          </p>
        </div>
        <div className="site-footer__cols">
          <div>
            <h3 className="site-footer__heading">Davetiyeler</h3>
            <ul className="site-footer__links">
              {davetiyeCategories.map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/davetiyeler/${cat.slug}`}>{cat.shortTitle}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="site-footer__heading">Şekerlik</h3>
            <ul className="site-footer__links">
              {sekerlikCategories.map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/sekerlik/${cat.slug}`}>{cat.shortTitle}</Link>
                </li>
              ))}
            </ul>
          </div>
          {whatsappHref && (
            <div className="site-footer__whatsapp">
              <h3 className="site-footer__heading">WhatsApp hattı</h3>
              <p className="site-footer__whatsapp-text">
                Sipariş ve tasarım sorularınız için mesaj gönderebilirsiniz.
              </p>
              <a
                href={whatsappHref}
                className="site-footer__whatsapp-btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                WhatsApp&apos;ta yaz
              </a>
            </div>
          )}
        </div>
      </div>
      <div className="site-footer__bottom">
        <p>
          © {new Date().getFullYear()} {siteName}. Tüm hakları saklıdır.
        </p>
      </div>
    </footer>
  );
}
